import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexProvider, ConvexReactClient } from "convex/react";
import * as Sentry from "@sentry/react";
import { createSentryOptions } from "@kolaborate/sentry/react";
import App from "./App.tsx";
import "./index.css";

const sentryOptions = createSentryOptions("bpo");
if (sentryOptions.enabled && sentryOptions.dsn) {
  Sentry.init(sentryOptions);
}

const convexUrl =
  import.meta.env.VITE_CONVEX_URL ||
  import.meta.env.NEXT_PUBLIC_CONVEX_URL ||
  "https://dummy.convex.cloud";
const convex = new ConvexReactClient(convexUrl);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConvexProvider client={convex}>
      <App />
    </ConvexProvider>
  </StrictMode>,
);
